import {controller, target} from '@github/catalyst'
@controller('notifications-team-subscription-form')
class NotificationsTeamSubscriptionFormElement extends HTMLElement {
  @target declare details: HTMLDetailsElement

  closeMenu() {
    this.details.toggleAttribute('open', false)
  }
}
